{
  "nl": {
    "continueSignIn": {
      "accountSwitch": {
        "title": "Account wisselen",
        "description": "Je {provider}-account is gekoppeld aan een ander fobizz-account. Wil je nu inloggen met dit account?",
        "confirm": "Ja, opnieuw inloggen",
        "cancel": "Annuleren"
      },
      "linkBlocked": {
        "title": "Account koppelen",
        "description": "Dit account is al gekoppeld aan een ander {provider}-account. Je moet eerst de koppeling in je instellingen verbreken en het proces opnieuw starten.",
        "confirm": "Naar mijn instellingen",
        "cancel": "Annuleren"
      },
      "linkAvailable": {
        "title": "Account koppelen",
        "description": "Je bent ingelogd met dit fobizz-account. Wil je je {provider}-account hiermee koppelen?",
        "confirm": "Ja, dit account gebruiken",
        "otherAccountsTitle": "Meer fobizz-accounts",
        "signIn": "Ander fobizz-account gebruiken",
        "createNew": "Nieuw account aanmaken",
        "cancel": "Annuleren"
      },
      "anonymous": {
        "title": "{provider}-aanmelding voortzetten",
        "description": "Wil je een bestaand fobizz-account koppelen of een nieuw account aanmaken?",
        "signIn": "Inloggen en koppelen",
        "createNew": "Account aanmaken met {provider}-gegevens",
        "cancel": "Annuleren"
      },
      "providers": {
        "google_oauth2": "Google",
        "microsoft_office365": "Microsoft",
        "apple": "Apple",
        "bildung_lsa": "Bildung-LSA",
        "edulog": "Edulog",
        "edupool": "Edupool",
        "entree": "Entree Federatie",
        "lux": "Lux",
        "untis": "WebUntis",
        "vidis": "VIDIS",
        "univention": "Univention",
        "austria": "Oostenrijk"
      },
      "errors": {
        "emailTaken": "Er bestaat al een account met dit e-mailadres."
      }
    }
  }
}
